import { useMemo } from 'react'
import { Select } from 'antd'
import type { PracticeAgentReportData, PracticeAgentVisualizationType } from '../../types'
import { classifyColumns, formatFieldDisplayName } from '../../utils'

export function SortControls({
  columns,
  rows,
  vizType,
  sortColumn,
  sortDirection,
  onChange,
  sortOptions,
}: {
  columns: string[]
  rows: PracticeAgentReportData['rows']
  vizType: PracticeAgentVisualizationType
  sortColumn: string | null
  sortDirection: 'asc' | 'desc'
  onChange: (col: string | null, dir: 'asc' | 'desc') => void
  sortOptions?: Array<{ value: string; label: string }>
}) {
  const { measureCols } = useMemo(() => classifyColumns(columns, rows), [columns, rows])
  const isKpi = vizType === 'KPI'
  const kpiMeasure = measureCols[0] ?? null

  const dirOptions = [
    { value: 'desc', label: 'Descending' },
    { value: 'asc', label: 'Ascending' },
  ]

  return (
    <div className="flex items-center gap-2">
      {!isKpi && (
        <>
          <span className="text-xs text-gray-500">Sort by</span>
          <Select
            size="small"
            value={sortColumn ?? undefined}
            onChange={(v: string) => onChange(v, sortDirection)}
            options={sortOptions ?? columns.map((c) => ({ value: c, label: formatFieldDisplayName(c) }))}
            style={{ minWidth: 160 }}
          />
        </>
      )}
      <Select
        size="small"
        value={sortDirection}
        onChange={(v: string) => onChange(isKpi ? kpiMeasure : sortColumn, v as 'asc' | 'desc')}
        options={dirOptions}
        style={{ minWidth: 110 }}
      />
    </div>
  )
}
